import React from "react";
import { Spin } from "antd";
import Link from "next/link";
import InfiniteScroll from "react-infinite-scroll-component";
import { formatDayjs } from "../../../services/localeFormat";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import ApiService from "../../../services/ApiService";
import { ASSET_URL } from "../../../config";
import renderIcon from "../../../components/renderIcon";



const listStyles = `
.tr-galeries__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 340px));
    gap: 24px;
    justify-content: center;
    max-width: 1180px;
    margin: 40px auto;
    padding: 0 16px;
}
@media (max-width: 640px) {
    .tr-galeries__grid { grid-template-columns: minmax(0, 400px); }
}

.tr-gcard {
    position: relative;
    display: block;
    text-decoration: none;
    color: inherit;
    aspect-ratio: 4/3;
    border-radius: 20px;
    overflow: hidden;
    background: #1a1a2e;
    box-shadow: 0 4px 16px rgba(0,0,0,.08), 0 1px 4px rgba(0,0,0,.04);
    transition: transform .25s ease, box-shadow .25s ease;
    cursor: pointer;
}
.tr-gcard:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 32px rgba(0,0,0,.16), 0 2px 6px rgba(0,0,0,.06);
}
.tr-gcard__img {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    transition: transform .4s ease;
}
.tr-gcard:hover .tr-gcard__img { transform: scale(1.06); }
.tr-gcard__img-placeholder {
    position: absolute; inset: 0;
    display: flex; align-items: center; justify-content: center;
    color: #4b5563;
    background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
}
.tr-gcard__wash {
    position: absolute; inset: 0;
    background: linear-gradient(180deg, rgba(9,18,26,0) 35%, rgba(9,18,26,.55) 65%, rgba(9,18,26,.92) 100%);
}
.tr-gcard__body {
    position: absolute; inset: auto 0 0 0;
    padding: 18px 20px 20px;
    color: white;
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.tr-gcard__name {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.25;
    color: white;
}
.tr-gcard__desc {
    font-size: 13px;
    color: rgba(255,255,255,.82);
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.tr-gcard__meta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: rgba(255,255,255,.78);
    padding-top: 8px;
    border-top: 1px solid rgba(255,255,255,.15);
    margin-top: 4px;
}

.tr-galeries__empty {
    text-align: center;
    padding: 64px 16px;
    color: #6b7280;
    font-size: 15px;
}
.tr-galeries__loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 24px 0;
}
`;

export default class ListRender extends React.Component {

    state = {
        data: [],
        loading: false,
        page: 0,
        finished: false,
    };

    componentDidMount() {
        this.setState({ loading: true }, () => {
            this.getData(true);
        });
    }

    async getData(init = false) {
        const context = this.props.context;
        const { org } = context;

        let page = this.state.page + 1;
        if (init) page = 1;

        this.setState({ loading: true });
        const res = await ApiService.post("/galeries/" + org.id, { page });

        const finalData = init ? res.data : [...this.state.data, ...res.data];
        const finished = res.data.length < 10;

        this.setState({
            loading: false,
            data: finalData,
            page,
            finished,
        });
    }

    render() {
        const context = this.props.context;
        const { org } = context;

        return (
            <div>
                <style dangerouslySetInnerHTML={{ __html: listStyles }} />

                {!this.state.loading && this.state.data.length === 0 && (
                    <div className="tr-galeries__empty">
                        <Trans>Cet organisme n'a pas encore de galerie.</Trans>
                    </div>
                )}

                {this.state.data.length > 0 && (
                    <InfiniteScroll
                        dataLength={this.state.data.length}
                        next={() => this.getData()}
                        hasMore={!this.state.finished}
                        loader={<div className="tr-galeries__loader"><Spin spinning /></div>}
                        style={{ overflow: "visible" }}
                    >
                        <div className="tr-galeries__grid">
                            {this.state.data.map(item => {
                                const imgSrc = item.bgImage ? `${ASSET_URL}/${item.bgImage}` : null;
                                return (
                                    <Link key={item.id} href={org.BASE_WEB_URL + "/galerie/" + item.id} legacyBehavior>
                                        <a className="tr-gcard">
                                            {imgSrc ? (
                                                <img src={imgSrc} alt={item.name} className="tr-gcard__img" loading="lazy" />
                                            ) : (
                                                <div className="tr-gcard__img-placeholder">
                                                    {renderIcon({ name: "IconPhoto", source: "tabler" }, 48)}
                                                </div>
                                            )}
                                            <div className="tr-gcard__wash" />
                                            <div className="tr-gcard__body">
                                                <div className="tr-gcard__name">{item.name}</div>
                                                {item.description && (
                                                    <div className="tr-gcard__desc">{item.description}</div>
                                                )}
                                                {item.datetime && (
                                                    <div className="tr-gcard__meta">
                                                        {renderIcon({ name: "IconCalendar", source: "tabler" }, 13)}
                                                        <span>{formatDayjs(item.datetime, context.langValue, "DD MMMM YYYY")}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </a>
                                    </Link>
                                );
                            })}
                        </div>
                    </InfiniteScroll>
                )}
            </div>
        );
    }
}
